<template>
  <!-- Midia do enunciado, da questao ou da alternativa. URL nula = arquivo
       sumido no bucket: some da tela em vez de quebrar o exercicio. -->
  <div
    v-if="visible.length"
    class="xmedia"
    :class="{ 'xmedia--compact': compact }"
  >
    <template v-for="(item, index) in visible">
      <img
        v-if="item.kind === 'image'"
        :key="`i${index}`"
        :src="item.url"
        alt=""
        loading="lazy"
        class="xmedia__img"
      />
      <!-- Retorno de 22/10 (card 17trt6jcyfb): vídeo do YouTube como base do
           exercício. A API manda o endereço de incorporar (youtube-nocookie),
           montado a partir do id do vídeo. -->
      <div
        v-else-if="item.kind === 'youtube'"
        :key="`y${index}`"
        class="xmedia__yt"
      >
        <iframe
          :src="item.url"
          title="YouTube"
          loading="lazy"
          allowfullscreen
          allow="encrypted-media; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <video
        v-else-if="item.kind === 'video'"
        :key="`v${index}`"
        :src="item.url"
        controls
        preload="metadata"
        playsinline
        class="xmedia__video"
      />
      <audio
        v-else
        :key="`a${index}`"
        :src="item.url"
        controls
        preload="none"
        class="xmedia__audio"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "ExerciseMedia",
  props: {
    media: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  computed: {
    visible() {
      return (this.media || []).filter((item) => item && item.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.xmedia {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
  margin: 12px 0;
}

.xmedia__img {
  max-width: min(100%, 420px);
  max-height: 300px;
  border-radius: 10px;
  border: 1px solid var(--dk-line, #ece6f5);
  background: var(--dk-surface, #fff);
}

.xmedia__video {
  width: min(100%, 560px);
  border-radius: 10px;
  background: #1c1730;
}

.xmedia__audio {
  width: min(100%, 360px);
}

.xmedia__yt {
  position: relative;
  width: min(100%, 640px);
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  background: #1c1730;
}

.xmedia__yt iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.xmedia--compact {
  margin: 6px 0;
}

.xmedia--compact .xmedia__img {
  max-height: 140px;
}
</style>
